module.exports = __webpack_public_path__ + "static/media/0073_Medium.58338cf3.jpg";